import React from 'react';
export default function Anchor(_ref) {
  var id = _ref.id;
  return /*#__PURE__*/React.createElement("span", {
    id: id,
    className: "ab-inv pt-80 lg:pt-100px -mt-80px lg:-mt-100px"
  }, "anchor");
}